import React from 'react';
import { Heading } from '../../components';

import css from '../../containers/ListingPage/ListingPage.module.css';

import { FaWheelchair, FaPills, FaHandHoldingWater } from 'react-icons/fa';
import { FaShieldDog, FaHandHoldingHeart } from 'react-icons/fa6';

const specialNeedsDisplayData = {
  disabled_pets: {
    name: 'Support for Disabled Pets (Blind/Deaf/Amputee)',
    icon: <FaWheelchair />,
  },

  senior_pet: {
    name: 'Senior Pet Care',
    icon: <FaHandHoldingHeart />,
  },

  medication: {
    name: 'Medication Administration',
    icon: <FaPills />,
  },

  anxious: {
    name: 'Support for Anxious Pets',
    icon: <FaShieldDog />,
  },

  hydro_physio: {
    name: 'Hydrotherapy / Physiotherapy',
    icon: <FaHandHoldingWater />,
  },
};

const SectionSpecialNeeds = props => {
  const { heading, selectedOptions = [] } = props;

  if (!heading || selectedOptions.length === 0) {
    return null;
  }
  const customHeading = 'Facilities for Pets with Special Needs';
  return (
    <section className={css.sectionCleaningFacilities}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {customHeading}
      </Heading>
      <ul className={css.topFacilitiesList}>
        {selectedOptions.map(option => {
          const feature = specialNeedsDisplayData[option];
          return (
            <li key={option} className={css.multiEnumItem}>
              <span className={css.facilityIcon}>{feature?.icon}</span>
              <span>{feature?.name || option}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default SectionSpecialNeeds;
